import discountDayGetter from '../valueGetters/discountDayGetter';

import currencyFormatter from '../formatters/priceFormatter';
import percentFormatter from '../formatters/percentFormatter';

import { getClassForAgGridCell } from '../../../helpers/cellHelpers';

import proposalDayPriceGetter from '../valueGetters/proposalDayPriceGetter';

import {
  Nullable,
  PricingSheetRow,
  RoundingBasis,
} from '../../../../../shared/types';

import { dayPriceGetter } from '../valueGetters/dayPriceGetter';

import {
  CellClassParams,
  ICellRendererParams,
  CellStyle,
  ValueGetterParams,
} from 'ag-grid-community';
import CommentRenderer from '../Renderers/CommentRenderer';
import { GridColumnProps } from './ColumnsBase';
import { getCatClassColDef } from '../helpers/getCatClassColDef';
import { PRICE_FACTOR } from '../../../../../shared/constants';

interface OptionalColumnProps {
  hideInspectComment: boolean;
  roundingBasisSheet: RoundingBasis;
}

const InspectColumnsDay = ({
  classes,
  gridGroupingValues,
  optionalColumnProps,
}: GridColumnProps<OptionalColumnProps>) => {
  const columns = [
    ...getCatClassColDef(gridGroupingValues),
    {
      field: 'rentalDaysDay',
      headerName: 'Vuokrapäivät',
      filter: 'agNumberColumnFilter',
      editable: false,

      valueFormatter: (params: { value: Nullable<number> }) => {
        return (params.value ?? 0) + ' pv';
      },
      headerTooltip: 'Asiakkaan vuokrapäivät viimeisen vuoden ajalta',
      suppressColumnsToolPanel: false,
      hide:
        localStorage.getItem('columnVisibility_rentalHistoryDays') ===
        'false',
      cellStyle: {
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #ccc',
      } as CellStyle,
    },
    {
      field: 'proposalDayPrice',
      headerName: 'EhdotusPVHinta',
      filter: 'agNumberColumnFilter',
      valueGetter: proposalDayPriceGetter,
      valueFormatter: currencyFormatter,
      headerTooltip: 'Työkalun ehdottama hinta päivähinnaksi',
      cellStyle: {
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #ccc',
      } as CellStyle,
    },
    {
      field: 'discountDay',
      headerName: 'Alennus% (PV)',
      filter: 'agNumberColumnFilter',
      valueGetter: discountDayGetter,
      valueFormatter: percentFormatter,
      headerTooltip: 'Päivähinta verrattuna ehdotushintaan',
      cellClass: (params: CellClassParams) => {
        return getClassForAgGridCell(
          params.data,
          classes,
          'discountDay',
        );
      },
      cellStyle: {
        borderLeft: '1px solid #ccc',
      },
    },
    {
      field: 'dayPrice',
      headerName: 'PVHinta',
      filter: 'agNumberColumnFilter',
      valueGetter: (params: ValueGetterParams<PricingSheetRow>) =>
        dayPriceGetter(
          params,
          optionalColumnProps.roundingBasisSheet,
        ),
      valueFormatter: currencyFormatter,
      headerTooltip: 'Tuotteen päivähinta',
      cellClass: (params: CellClassParams) => {
        return getClassForAgGridCell(
          params.data,
          classes,
          'dayPrice',
        );
      },
      cellStyle: () => {
        return {
          color: '#000',
          borderLeft: '1px solid #ccc',
          borderRight: '1px solid #ccc',
        } as CellStyle;
      },
    },
    {
      field: 'estimatedYield',
      headerName: 'Laskennallinen tuotto',
      filter: 'agNumberColumnFilter',
      editable: false,

      valueFormatter: (params: {
        value: Nullable<number>;
        data: PricingSheetRow | undefined;
      }) => {
        return (
          Number(
            (params.data?.estimatedYieldDay ?? 0) / PRICE_FACTOR,
          ).toFixed(2) + ' €'
        );
      },
      headerTooltip: 'Asiakkaan vuokrapäivät viimeisen vuoden ajalta',
      suppressColumnsToolPanel: false,
      hide:
        localStorage.getItem('columnVisibility_estimatedYield') ===
        'false',
    },
    {
      field: 'comment',
      headerName: 'Kommentti',
      minWidth: 200,
      hide: optionalColumnProps.hideInspectComment,
      cellRenderer: (params: ICellRendererParams) => {
        return <CommentRenderer row={params?.data} />;
      },
    },
  ];
  return columns;
};

export default InspectColumnsDay;
